module.exports = __webpack_public_path__ + "media/images/icons/ok-36d7589e98d9d46a556d02f0cb83cccd.svg";